import reducer, { actions, initialState } from './slice';
import * as asyncActions from './asyncActions';
import * as selectors from './selectors';

export const noticeStore = {
  initialState,
  actions,
  asyncActions,
  selectors,
};

export default reducer;
